<div class="row clearfix">
  <div class="col-md-12">
    <div class="card">
      <div class="header">
        <h2>Filtro</h2>
      </div>
      <div class="body">
        <div class="row">

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Filtrando por:</mat-label>
              <mat-select [(ngModel)]="search.field">
                <mat-option value="nome">Nome</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Tipo Filtro</mat-label>
              <mat-select [(ngModel)]="search.option">
                <mat-option *ngFor="let option of filterOptions" [value]="option.value">{{option.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Pesquisar por</mat-label>
              <input matInput type="text" [(ngModel)]="search.searchTerm" (keyup.enter)="filter()" />
              <mat-error>Informe um titulo válido.</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Tipo Solicitação</mat-label>
              <mat-select [(ngModel)]="searchTipoSolicitacao.searchTerm" (selectionChange)="getTipoSolicitacao($event.value)">
                <mat-option value="">Todas as Solicitações</mat-option>
                <mat-option *ngFor="let solicitacao of tiposSolicitacoes" [value]="solicitacao.value">{{solicitacao.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="searchStatus.searchTerm" (selectionChange)="getStatusPossiveis($event.value)">
                <mat-option value="">Todos os Status</mat-option>
                <mat-option *ngFor="let status of statusPossiveis" [value]="status.value">{{status.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Filtrando Data por:</mat-label>
              <mat-select [(ngModel)]="filtroDataSelecionado" (selectionChange)="getSearchData($event.value)">
                <mat-option value="Nao filtrar data">Não Filtrar Data</mat-option>
                <mat-option *ngFor="let opcao of opcoesDatas" [value]="opcao.value">{{opcao.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 1">
            <mat-form-field>
              <mat-label>Período do Contato</mat-label>
              <input matInput [(ngModel)]="searchDataInicialContato.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>
          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 1">
            <mat-form-field>
              <input matInput [(ngModel)]="searchDataFinalContato.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>

          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 2">
            <mat-form-field>
              <mat-label>Período de Status</mat-label>
              <input matInput [(ngModel)]="searchDataInicialStatus.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>
          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 2">
            <mat-form-field>
              <input matInput [(ngModel)]="searchDataFinalStatus.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>

        </div>
      </div>
      <div class="footer">
        <button mat-flat-button color="primary" (click)="filter()">
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="card">
      <div class="header">
        <h2>Requisições LGPD</h2>
      </div>
      <div class="body table-responsive">
        <!--query end-->
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover"
          style="width: 100%;">
          <thead>
            <tr>
              <th class="text-center" width="100">Data</th>
              <th class="text-center" width="100">Status</th>
              <th class="text-center" width="100">Data Status</th>
              <th class="text-center">Nome</th>
              <th class="text-center" width="100">Telefone</th>
              <th class="text-center" width="100">Tipo Solicitação</th>
              <th class="text-center" width="150"></th>
            </tr>
          </thead>
          <tbody *ngIf="models?.length != 0">
            <tr *ngFor="let requisicao of models">
              <td>
                {{requisicao.data  | date:'dd/MM/yyyy HH:mm'}}
              </td>
              <td>
                {{getStatusPossiveis(requisicao.status)}}
              </td>
              <td>
                {{requisicao.dataStatus  | date:'dd/MM/yyyy HH:mm'}}
              </td>
              <td>
                {{requisicao.nome}}
              </td>
              <td>
                {{requisicao.telefone}}
              </td>
              <td>
                {{getTipoSolicitacao(requisicao.tipoSolicitacao)}}
              </td>
              <td class="text-center">
                <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(requisicao)" matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(requisicao.id)" matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
      </table>
    </div>
    <div class="fixed-action-btn">
      <button [disabled]="!isAllowed('Create')" mat-fab color="primary" (click)="create()" matTooltip="Adicionar (F9)" matTooltipPosition="above">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
</div>
<app-requisicao-lgpd-modal #requisicaoLgpdModal (modalSave)="onResponse($event)"></app-requisicao-lgpd-modal>

